// components/BrowseByCategory.tsx
import React from 'react';
import Image from 'next/image';
import acdc from '@/public/assets/images/ACDCbox.png';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';

interface Category {
  title: string;
  image: string | StaticImport; // Path to the image file (e.g., '/images/electrical-systems.png')
}

const BrowseByCategory: React.FC = () => {
  const categories: Category[] = [
    {
      title: 'Electrical Systems',
      image: acdc, // Place your image files in the public/images folder
    },
    {
      title: 'CCTV Solutions',
      image: acdc,
    },
    {
      title: 'Solar power',
      image: acdc,
    },
    {
      title: 'Home Automation',
      image: acdc,
    },
    {
      title: 'Smart Lighting',
      image: acdc,
    },
  ];

  return (
    <section className="w-full bg-[#E8EBF4] py-12">
      <div className="max-w-[1250px] mx-auto px-4">

        {/* Heading */}
        <h2 className="text-center font-lato md:text-[40px] text-[20px] font-bold text-black mb-10">
          Browse by Category
        </h2>

        {/* Categories */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 justify-center gap-6 flex-wrap">
          {categories.map((item, index) => (
            <a href="/products/testing-product">
              <div
                key={index}
                className=" bg-white rounded-[12px] border-2 border-dashed border-purple-300 p-4 text-center hover:border-purple-500 transition-colors duration-200 transform hover:scale-[1.02] active:scale-[0.98] "
              >
                <p className="md:text-[20px] text-[10px] font-semibold text-gray-700 mb-[24px] whitespace-nowrap">
                  {item.title}
                </p>

                <div className="flex justify-center mb-[15px]">
                  <Image
                    src={item.image}
                    alt={item.title}
                    width={122}
                    height={122}
                    className="object-contain"
                  />
                </div>
              </div>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BrowseByCategory;